import * as React from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import Input from '../../Input/Input';
import Dialog from '@material-ui/core/Dialog';
import ru from 'date-fns/locale/ru';
import { useMediaQuery } from 'react-responsive';
import DateInputFormat from '../../DateInputFormat/DateInputFormat';
import InputAdornment from '@material-ui/core/InputAdornment';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';

interface Props {
	name: string;
	label: string;
	error?: boolean;
	onChange?: (event: any) => void;
	onBlur?: (event: any) => void;
	defaultDate?: Date;
	openDate?: Date;
	value?: string;
	minYear?: number;
	disableDelete?: boolean;
	hideDay?: boolean;
}

const CalendarContainer: React.FC = props => {
	return <Dialog open={true}>
		{props.children}
	</Dialog>
};


const DateInput: React.FunctionComponent<Props> = props => {
	const [date, setDate] = React.useState(props.openDate || new Date());
	const isMobile = useMediaQuery({ maxWidth: "600px" });

	React.useEffect(() => {
		setDate(props.openDate);
	}, [props.openDate]);

	const onChange = (date: Date) => {
		setDate(date);

		props.onChange(date?.toISOString());
	}

	const onClear = () => {
		setDate(null);
		props.onChange('');
	};

	return <>
		{!isMobile && <DatePicker
			selected={date}
			onChange={onChange}
			dateFormat={props.hideDay ? "LLLL, yyyy" : "dd.MM.yyyy"}
			openToDate={props.defaultDate}
			locale={ru}
			customInput={
				<Input
					className="edit__section__field"
					onChange={event => {
						props.onChange(event)
					}}
					onBlur={event => {
						props.onBlur(event)
					}}
					name={props.name}
					error={props.error}
					label={props.label}
					InputProps={{
						endAdornment: date && !props.disableDelete && <InputAdornment position="end">
							<IconButton onClick={onClear}>
								<CloseIcon/>
							</IconButton>
						</InputAdornment>
					}}
				/>
			}
			withPortal={isMobile}
			popperPlacement="top-center"
			showMonthYearPicker={props.hideDay}
		/>}

		{isMobile && <DateInputFormat
			name={props.name}
			date={props.value}
			onChange={onChange}
			label={props.label}
			minYear={props.minYear}
			disableDelete={props.disableDelete}
			hideDay={props.hideDay}
		/>}
	</>;
};

export default DateInput;